import add from "../coordinate/add";
export default function middleCoordinate(coordinates) {
    return coordinates.reduce(add, [0, 0]).map((a) => a / coordinates.length);
}
